import { render, staticRenderFns } from "./allRecord.vue?vue&type=template&id=7ae87eda&scoped=true"
import script from "./allRecord.vue?vue&type=script&lang=js"
export * from "./allRecord.vue?vue&type=script&lang=js"
import style0 from "./allRecord.vue?vue&type=style&index=0&id=7ae87eda&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae87eda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ae87eda')) {
      api.createRecord('7ae87eda', component.options)
    } else {
      api.reload('7ae87eda', component.options)
    }
    module.hot.accept("./allRecord.vue?vue&type=template&id=7ae87eda&scoped=true", function () {
      api.rerender('7ae87eda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/trackSendingManagement/component/allRecord.vue"
export default component.exports